import { observer } from 'mobx-react-lite';
import { useData } from '@microsoft/teamsfx-react';
import { Spinner } from '@fluentui/react-components';

import { useStore } from 'src/hooks/useStore';
import { useAppDataBootstrapStyles } from './AppDataBootstrap.styles';

const AppDataBootstrap = observer((props: { children: React.ReactNode }) => {
  const { profileStore } = useStore();
  const styles = useAppDataBootstrapStyles();
  const { loading: isProfileLoading, error: loadProfileError, data: profileData } = useData(profileStore.loadProfile);

  if (loadProfileError) {
    throw loadProfileError;
  }

  if (isProfileLoading || !profileData) {
    return <Spinner className={styles.spinner} />;
  }

  return <>{props.children}</>;
});

export default AppDataBootstrap;
